
import React, { useEffect, useState } from 'react';
import axiosInstance from '../../axiosInstance';
import { useNavigate } from "react-router-dom";
import { LogOut, Key } from 'lucide-react';

function CompanyUserProfile() {
  const [user, setUser] = useState({});
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await axiosInstance.get("/company/getCompanyDetail");
        setUser(response.data.data);
      } catch (error) {
        console.log("Error fetching company details:", error);
      }
    };

    fetchCompanyDetails();
  }, []);

  const handlePasswordClick = () => {
    navigate('/forgot-password');
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div className='bg-gray-900 min-h-screen p-0 overflow-y-auto'
      style={{
        scrollbarWidth: 'thin',
        msOverflowStyle: 'none'
      }}>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gray-800 rounded-xl p-6 max-w-md w-full border border-gray-700">
            <h3 className="text-xl font-semibold text-white mb-3">Confirm Logout</h3>
            <p className="text-gray-300 mb-6">Are you sure you want to sign out of your account?</p>
            <div className="flex justify-end gap-3">
              <button 
                onClick={() => setShowLogoutConfirm(false)}
                className="px-4 py-2 rounded-lg bg-gray-700 text-white hover:bg-gray-600 transition-colors"
              >
                Cancel
              </button>
              <button 
                onClick={handleLogout}
                className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors flex items-center gap-2"
              >
                <LogOut className="w-4 h-4" />
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="max-w-4xl mx-auto my-8 p-6 sm:p-8 bg-gray-900 rounded-2xl shadow-lg border border-gray-800">
        <div className="flex justify-between items-start mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-blue-500">Company Profile</h1>
          <button 
            onClick={() => setShowLogoutConfirm(true)}
            className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors group"
          >
            <span className="hidden sm:inline">Sign Out</span>
            <LogOut className="w-5 h-5 group-hover:rotate-12 transition-transform" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Company Name */}
          <div>
            <label className="block text-gray-400 mb-2 text-sm font-medium">Company Name</label>
            <div className="w-full p-3 rounded-lg bg-gray-800 text-gray-100 border border-gray-700">
              {user.company_name || "N/A"}
            </div>
          </div>

          {/* Concerned Person */}
          <div>
            <label className="block text-gray-400 mb-2 text-sm font-medium">Concerned Person</label>
            <div className="w-full p-3 rounded-lg bg-gray-800 text-gray-100 border border-gray-700">
              {user.owner || "N/A"}
            </div>
          </div>

          {/* Email */}
          <div>
            <label className="block text-gray-400 mb-2 text-sm font-medium">Email</label>
            <div className="w-full p-3 rounded-lg bg-gray-800 text-gray-100 border border-gray-700">
              {user.company_email || "N/A"}
            </div>
          </div>

          {/* Phone */}
          <div>
            <label className="block text-gray-400 mb-2 text-sm font-medium">Phone</label>
            <div className="w-full p-3 rounded-lg bg-gray-800 text-gray-100 border border-gray-700">
              {user.phone || "N/A"}
            </div>
          </div>

          {/* Password */}
          <div>
            <label className="block text-gray-400 mb-2 text-sm font-medium">Password</label>
            <div className="w-full p-3 rounded-lg bg-gray-800 text-gray-100 border border-gray-700">
            {user.password || "N/A"}
            </div>
          </div>

          {/* Expiry Date */}
          <div>
            <label className="block text-gray-400 mb-2 text-sm font-medium">Expiry Date</label>
            <div className="w-full p-3 rounded-lg bg-gray-800 text-gray-100 border border-gray-700">
              {user.company_expiry ? new Date(user.company_expiry).toLocaleDateString("en-GB") : "N/A"}
            </div>
          </div>
        </div>

        {/* Forget Password Button */}
        <div className="mt-8 flex justify-end">
          <button 
            onClick={handlePasswordClick}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-colors"
          >
            {/* <Key className="w-4 h-4" /> */}
            Forget Password
          </button>
        </div>
      </div>
    </div>
  )
}

export default CompanyUserProfile;
// import React, { useEffect } from 'react';
// import axiosInstance from '../../axiosInstance';
// import { useNavigate } from "react-router-dom";

// function CompanyUserProfile() {
//   const [user, setUser] = React.useState({})
//   const navigate = useNavigate();
//   useEffect(() => {
//     const fetchCompanyDetails = async () => {
//       try {
//         const response = await axiosInstance.get("/company/getCompanyDetail");
//         console.log("Response data for company profile:", response.data.data);
//         setUser(response.data.data); // Ensure you're setting the correct data
//       } catch (error) {
//         console.log("Error fetching company details:", error);
//       }
//     };

//     fetchCompanyDetails();
//   }, []);


//   const handleProjectClick = () => {
//     navigate('/forgot-password');
//   };
//   return (
//     <div className='bg-gray-900 h-[100vh] p-0'
//       style={{
//         overflowY: 'scroll',
//         height: '100vh',
//         width: '100%',
//         scrollbarWidth: '1px',
//         msOverflowStyle: 'none'
//       }}>


//       <div className="max-w-4xl mx-auto my-8 p-8 bg-gray-900 rounded-2xl shadow-lg border">
//         <h1 className="text-3xl font-bold text-blue-600 mb-6 text-center">Company Profile</h1>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//           {/* Company Name */}
//           <div>
//             <label className="block text-white mb-1">Company Name</label>
//             <input
//               type="text"
//               value={user.company_name || "N/A"}
//               readOnly
//               className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-700"
//             />
//           </div>

//           {/* Name */}
//           <div>
//             <label className="block text-white mb-1">Concerned Person</label>
//             <input
//               type="text"
//               value={user.owner || "N/A"}
//               readOnly
//               className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-700"
//             />
//           </div>

//           {/* Email */}
//           <div>
//             <label className="block text-white mb-1">Email</label>
//             <input
//               type="email"
//               value={user.company_email || "N/A"}
//               readOnly
//               className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-700"
//             />
//           </div>

//           {/* Phone */}
//           <div>
//             <label className="block text-white mb-1">Phone</label>
//             <input
//               type="text"
//               value={user.phone || "N/A"}
//               readOnly
//               className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-700"
//             />
//           </div>

//           {/* Password */}
//           <div>
//             <label className="block text-white mb-1">Password</label>
//             <input
//               type="password"
//               value="********"
//               readOnly
//               className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-700"
//             />
//           </div>

//           {/* Expiry Date */}
//           <div>
//             <label className="block text-white mb-1">Expiry Date</label>
//             <input
//               type="text"
//               // value="2025-12-31"
//               value={user.company_expiry ? new Date(user.company_expiry).toLocaleDateString("en-GB") : "N/A"}

//               readOnly
//               className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100 text-gray-700"
//             />
//           </div>
//         </div>

//         {/* Forget Password Button */}
//         <div className="mt-6 text-right">
//           <button onClick={() => handleProjectClick()} className="bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700">
//             Forget Password
//           </button>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default CompanyUserProfile;
